module.exports = __webpack_public_path__ + "assets/img/dcthree.e7a2b720.png";